'use client';

import { Prose } from '@/components/ArticleAccessibilityMenu/ArticleAccessibilityTextSize';
import H1 from '@/components/MDX/H1';
import { PersonaPageList } from '@/components/Persona/PersonaPageList';
import { useLayoutEffect, useState } from 'react';

const EmbeddedPersonas = () => {
	const [showContent, setShowContent] = useState<boolean>(false);

	useLayoutEffect(() => {
		setShowContent(true);
	}, []);

	return (
		<>
			{showContent && (
				<Prose as="header" className="mb-8">
					<H1>Persona&apos;s</H1>
				</Prose>
			)}
			<div className="not-prose">
				<PersonaPageList />
			</div>
		</>
	);
};

export default EmbeddedPersonas;
